var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#34AADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1282 19.2921C11.1282 19.2921 19.2661 15.8645 22.0884 14.6576C23.1704 14.1749 26.8394 12.63 26.8394 12.63C26.8394 12.63 28.5329 11.9542 28.3918 13.5955C28.3447 14.2714 27.9684 16.6369 27.5921 19.1955C27.0276 22.8162 26.4161 26.7748 26.4161 26.7748C26.4161 26.7748 26.322 27.8852 25.5223 28.0782C24.7227 28.2713 23.4055 27.4024 23.1704 27.2093C22.9822 27.0645 19.6424 24.892 18.4193 23.83C18.0901 23.5403 17.7138 22.9611 18.4663 22.2852C20.1598 20.6921 22.1825 18.7128 23.4055 17.4576C23.97 16.8783 24.5345 15.5266 22.1825 17.1679C18.8427 19.5335 15.5499 21.7541 15.5499 21.7541C15.5499 21.7541 14.7973 22.2369 13.3861 21.8024C11.9749 21.368 10.3285 20.7886 10.3285 20.7886C10.3285 20.7886 9.19958 20.0645 11.1282 19.2921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.b1a01babedf6dc4aecf57c384c6a8857.svg";
export { ForwardRef as ReactComponent };